$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('instructions-download')) {
    customElements.define(
      'instructions-download',
      class InstructionsDownload extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.initTabSwitch();
          this.initDownloadButtons();
        }

        /**
         * 初始化标签页切换功能
         */
        initTabSwitch() {
          const listItems = this.querySelectorAll('.instructions-download__wrapper-content-list-item');
          const contentCollections = this.querySelectorAll(
            '.instructions-download__wrapper-content-list-item-content-collection'
          );

          if (!listItems.length || !contentCollections.length) return;

          // 为每个列表项添加点击事件
          listItems.forEach((item) => {
            item.addEventListener('click', (e) => {
              e.preventDefault();
              this.switchTab(item);
            });
          });
        }

        /**
         * 切换标签页
         */
        switchTab(clickedItem) {
          const listItems = this.querySelectorAll('.instructions-download__wrapper-content-list-item');
          const contentCollections = this.querySelectorAll(
            '.instructions-download__wrapper-content-list-item-content-collection'
          );

          // 获取点击项的 collection id
          const clickedCollectionId = clickedItem.getAttribute('data-collection-id');

          if (!clickedCollectionId) return;

          // 移除所有列表项的 active 样式
          listItems.forEach((item) => {
            item.classList.remove('active');
          });

          // 隐藏所有内容区域
          contentCollections.forEach((collection) => {
            collection.classList.add('hidden');
            collection.classList.remove('block');
          });

          // 为点击的列表项添加 active 样式
          clickedItem.classList.add('active');

          // 显示对应的内容区域
          const targetCollection = this.querySelector(
            `.instructions-download__wrapper-content-list-item-content-collection[data-collection-id="${clickedCollectionId}"]`
          );
          if (targetCollection) {
            targetCollection.classList.remove('hidden');
            targetCollection.classList.add('block');
          }

          // 移动端滚动到最左侧
          this.scrollToLeftOnMobile(clickedItem);
        }

        /**
         * 初始化下载按钮功能
         */
        initDownloadButtons() {
          const downloadBtns = this.querySelectorAll('.download-btn');

          downloadBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation(); // 防止触发父级的 tab 切换事件

              const downloadUrl = btn.getAttribute('data-download-url');
              if (downloadUrl) {
                // 检测是否为 iOS Safari
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                if (isIOS) {
                  // iOS Safari 使用简单的下载方式
                  const link = document.createElement('a');
                  link.href = downloadUrl;
                  link.download = this.getCleanFilename(downloadUrl);
                  link.target = '_blank';
                  link.click();
                } else {
                  // 其他浏览器使用 fetch 强制下载
                  fetch(downloadUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                      // 创建临时 URL
                      const blobUrl = window.URL.createObjectURL(blob);

                      // 创建下载链接
                      const link = document.createElement('a');
                      link.href = blobUrl;

                      // 提取干净的文件名
                      link.download = this.getCleanFilename(downloadUrl);

                      // 触发下载
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      // 清理临时 URL
                      window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch((error) => {
                      console.error('下载失败:', error);
                      // 回退到简单的 a 标签下载
                      const link = document.createElement('a');
                      link.href = downloadUrl;
                      link.download = this.getCleanFilename(downloadUrl);
                      link.target = '_blank';
                      link.click();
                    });
                }
              }
            });
          });
        }
        getCleanFilename(url) {
          return (url.split('/').pop() || 'download').replace(/\?.*$/, '');
        }
        /**
         * 移动端点击时滚动到最左侧
         */
        scrollToLeftOnMobile(clickedItem) {
          const listContainer = this.querySelector('.instructions-download__wrapper-content-list');
          if (!listContainer || window.innerWidth > 960) return;

          // 获取点击项在列表中的位置
          const items = Array.from(listContainer.querySelectorAll('.instructions-download__wrapper-content-list-item'));
          const itemIndex = items.indexOf(clickedItem);

          if (itemIndex === -1) return;

          // 计算点击项的位置
          let scrollPosition = 0;

          // 计算前面所有项的宽度总和
          for (let i = 0; i < itemIndex; i++) {
            scrollPosition += items[i].offsetWidth + 16; // 16px 是 gap
          }

          // 平滑滚动到点击项的位置
          listContainer.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
          });
        }
      }
    );
  }
});
